module.exports = __webpack_public_path__ + "static/media/task.2b38cbc8.png";